import { IAction, IState } from './UseTemplateCreateContext';

export type ActionTypes = 'SET_TEMPLATE_TYPES';

export function TemplateCreateReducer(state: IState, action: IAction) {
  const { payload } = action;
  let newState: IState = null;
  switch (action.type) {
    case 'SET_TEMPLATE_TYPES':
      newState = {
        ...state,
        types: payload.types,
      };
      break;
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
  return newState;
}
